// src/context/AuthContext.jsx
import React, { createContext, useContext, useState, useEffect } from 'react';
import { API_BASE_URL } from '../config/constants';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:wght,FILL,GRAD@200..700,0..1,0,0';
    document.head.appendChild(link);

    const checkAuth = async () => {
      const queryParams = new URLSearchParams(window.location.search);
      let token = queryParams.get('token');

      if (token) {
        localStorage.setItem('token', token);
        window.history.replaceState({}, document.title, window.location.pathname);
      } else {
        token = localStorage.getItem('token');
      }

      if (token) {
        try {
          const cachedUser = localStorage.getItem('userInfo');

          if (cachedUser) {
            setUserInfo(JSON.parse(cachedUser));
            setIsAuthenticated(true);
          } else {
            const response = await fetch(`${API_BASE_URL}/userGetInfoByToken?token=${token}`);
            if (!response.ok) throw new Error('Dohvaćanje korisnika nije uspjelo');

            const data = await response.json();
            const userDetails = {
              userID: data.userID,
              companyID: data.companyID,
              fullName: data.fullName,
              phoneNumber: data.phoneNumber,
              email: data.email
            };

            localStorage.setItem('userInfo', JSON.stringify(userDetails));
            setUserInfo(userDetails);
            setIsAuthenticated(true);
          }
        } catch (error) {
          console.error("AuthContext: Greška pri autentifikaciji:", error);
          logout();
        }
      } else {
        setIsAuthenticated(false);
      }
    };

    checkAuth();
  }, []);

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userInfo');
    sessionStorage.clear();
    setUserInfo(null);
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, userInfo, logout, setIsAuthenticated }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}